import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row } from 'reactstrap';
import {
  COMMERCIAL_STATUS,
  REGISTERED_BUS_FLEET_OPTIONS,
} from '../../../../config/constants';

const TOTAL_FLEET_KEY = REGISTERED_BUS_FLEET_OPTIONS.TOTAL_FLEET.value;

export const generateCounterRows = (counters) => {
  if (!counters) return [];

  const totalCount = counters[TOTAL_FLEET_KEY] || 0;

  const rows = Object.keys(REGISTERED_BUS_FLEET_OPTIONS)
    .filter((statusKey) => statusKey !== 'TOTAL_FLEET')
    .map((statusKey) => {
      const { value, label, order } = REGISTERED_BUS_FLEET_OPTIONS[statusKey];
      const count = counters[value] || 0;
      const exactPercentage = totalCount ? (count * 100) / totalCount : 0;

      return {
        id: value,
        color: COMMERCIAL_STATUS[statusKey]
          ? COMMERCIAL_STATUS[statusKey].color
          : 'secondary',
        label,
        count,
        exactPercentage,
        percentage: Number(exactPercentage.toFixed(2)),
        order,
      };
    })
    .sort((rowA, rowB) => rowA.order - rowB.order);

  const roundedTotal = rows.reduce((sum, row) => sum + row.percentage, 0);
  const diff = Number((100 - roundedTotal).toFixed(2));

  if (rows.length && diff !== 0) {
    const target = rows.reduce((rowA, rowB) =>
      rowA.exactPercentage > rowB.exactPercentage ? rowA : rowB,
    );
    target.percentage = Number((target.percentage + diff).toFixed(2));
  }

  return [
    ...rows,
    {
      id: TOTAL_FLEET_KEY,
      color: 'dark',
      label: REGISTERED_BUS_FLEET_OPTIONS.TOTAL_FLEET.label,
      count: totalCount,
      percentage: 100,
      isTotal: true,
      order: REGISTERED_BUS_FLEET_OPTIONS.TOTAL_FLEET.order,
    },
  ];
};

const FleetStatusCounterCards = ({ counters }) => {
  const rows = generateCounterRows(counters);

  if (!rows.length) return null;

  return (
    <Row className="mb-4">
      {rows.map(({ id, color, label, count, percentage }) => (
        <Col key={id} md={2} sm={4} xs={6} className="mb-2">
          <Card className={`h-100 text-center border-${color}`}>
            <CardBody className="p-3">
              <div
                className={`text-${color} text-uppercase font-weight-bold small`}
              >
                {label}
              </div>
              <div className="display-4">{count}</div>
              <div className="h4 text-muted mb-0">{`${percentage}%`}</div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

FleetStatusCounterCards.propTypes = {
  counters: PropTypes.shape({}),
};

FleetStatusCounterCards.defaultProps = {
  counters: null,
};

export default FleetStatusCounterCards;
